import React, { Component } from 'react';
import TopNav from '../../pages/Nav/LandingTopNav';
import "./Legal.css";

class Terms extends Component {
  render() {
    const {
      title,
      link,
    } = this.props;
    return (
      <div className="Legal-container">
        <TopNav onClick={this.onClick} />
        <iframe title={title} className="Legal-iframe" src={link}></iframe>
      </div>
    );
  }
}

export default Terms


// WEBPACK FOOTER //
// ./src/entries/Legal/Legal.js